
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { AsapBaseCRUD } from 'app/@core/lib/asap-base-crud.component';
import { AsapService } from 'app/@core/lib/asap.service';
import { Global } from 'app/@core/lib/global';

@Component({
    selector: 'asap-payment-config',
    templateUrl: './payment-config.component.html',
    styleUrls: [],
    providers: [AsapService]
})

export class PaymentConfigComponent extends AsapBaseCRUD implements OnChanges {

    @Input() targetType;
    @Input() targetID;

    constructor(
        public global: Global,
        public service: AsapService
    ) {
        super(global, service);
        this.service.basePath = "api/v2/admin";
        this.service.entityName = "payment-config";
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.targetID && this.targetType && (changes.targetType || changes.targetID)) {
            this.listAll(0, () => {
                if (this.list && this.list.length) {
                    this.entity = this.list[0];
                }
                else {
                    this.entity = this.defaults();
                }
            });
        }
    }

    public defaults() {
        return {
            target_id: this.targetID,
            target_type: this.targetType,
            config: {
                checkout: 'cielo',
                valorTotal: 0,
                desconto: 0,
                parcelas: 0,
                formaPagamento: {
                    credito: false,
                    debito: false,
                    boleto: false
                }
            }
        }
    }

    public listCondition() {
        return {
            query: 'search=' + btoa(`(target_type = '${this.targetType}') AND (target_id = '${this.targetID}')`)
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/payment-config/payment-config.component.ts